import { render, staticRenderFns } from "./ProfileItems.vue?vue&type=template&id=aca841c4&"
import script from "./ProfileItems.vue?vue&type=script&lang=ts&"
export * from "./ProfileItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aca841c4')) {
      api.createRecord('aca841c4', component.options)
    } else {
      api.reload('aca841c4', component.options)
    }
    module.hot.accept("./ProfileItems.vue?vue&type=template&id=aca841c4&", function () {
      api.rerender('aca841c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/components/ProfileItems.vue"
export default component.exports